var map = {
	"./academic-icon.svg": "a913",
	"./attention-icon.svg": "93d6",
	"./bell-icon.svg": "794c",
	"./branch-icon.svg": "5ca3",
	"./chat-icon.svg": "eb77",
	"./check-icon.svg": "461a",
	"./credit-card-icon.svg": "7942",
	"./facebook-icon.svg": "f26f",
	"./graph-icon.svg": "5db4",
	"./idea-icon.svg": "a89d",
	"./instagram-icon.svg": "9816",
	"./like-icon.svg": "7bbf",
	"./linkedin-icon.svg": "a5df",
	"./minus-icon.svg": "384d",
	"./money-icon.svg": "d96e",
	"./navbar-toggler-icon.svg": "d809",
	"./payment-icon.svg": "9b81",
	"./people-icon.svg": "dfc3",
	"./pizza-icon.svg": "b6c2",
	"./plus-icon.svg": "dbdd",
	"./rocket-icon.svg": "5ed3",
	"./screen-icon.svg": "bace",
	"./star-icon.svg": "feb6",
	"./wallet-icon.svg": "c22a",
	"./whatsapp-icon.svg": "d312",
	"./x-icon.svg": "5215"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9ff";